module.exports = __webpack_public_path__ + "static/img/logo_transparent_background.93d33d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_transparent_background.png
// module id = H2U8
// module chunks = 1